import { createRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { zodValidator } from '@tanstack/zod-adapter';
import { genericMessageQueryParamsSchema } from '@Pages/genericMessagePage/queryParamsSchema';
import { FailedUpload } from '@Pages/verificationCenter/FailedUpload';
import { KybPendingPage } from '@Pages/verificationCenter/KybPending';
import VerificationCenter from '@Pages/verificationCenter/VerificationCenter';
import { beforeLoadGeneral } from '@Router/middleware';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { handleGenericError } from '@Router/routesUtil/RoutesUtil';
import { GeneralSpinner } from '@Components/generalSpinner';
import { DebitCardNamePage, GenericMessage, UnderReview } from '..';
import { rootRoute } from './rootRoute';

const KybPendingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.KYB_PENDING].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.KYB_PENDING, shouldUpdateServerNavStack: false });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <KybPendingPage />
    </Suspense>
  ),
});
const VerificationCenterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.VERIFICATION_CENTER].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.VERIFICATION_CENTER, shouldUpdateServerNavStack: false });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <VerificationCenter />
    </Suspense>
  ),
});

const faildUploadRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.FAILD_UPLOAD].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.HOME_ADDRESS, shouldUpdateServerNavStack: false });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <FailedUpload />
    </Suspense>
  ),
});
const debitCardNameRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.DEBIT_CARD_NAME].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.DEBIT_CARD_NAME, shouldUpdateServerNavStack: false });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <DebitCardNamePage />
    </Suspense>
  ),
});

const genericMessageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.GENERIC_MESSAGE_PAGE].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.GENERIC_MESSAGE_PAGE,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <GenericMessage />
    </Suspense>
  ),
  validateSearch: zodValidator(genericMessageQueryParamsSchema),
  onError: handleGenericError,
});

const underReviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.UNDER_REVIEW].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.UNDER_REVIEW, shouldUpdateServerNavStack: false });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <UnderReview />
    </Suspense>
  ),
});

export const yellowLaneRoutes = [
  KybPendingRoute,
  VerificationCenterRoute,
  faildUploadRoute,
  debitCardNameRoute,
  genericMessageRoute,
  underReviewRoute,
];
